export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const skip_avatar = require("../assets/skip_avatar.png");
export const next = require("../assets/next.png")
export const trueIcon = require("../assets/trueIcon.png")
export const profileHover = require("../assets/profileHover.png")
export const evrybrand = require("../assets/group_LogoEverybrand.png")
export const thumbnail = require("../assets/thumbnail.png")
export const Play = require("../assets/play.png")

